module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAx0lEQVR4AbzUMQ7CMAyF4YSNjrByOO7QkY6ssHJAZtau4X9ShCLhpHGEQDaxwPlwQ9Vd+PHrf2BKaVJ6L8CcMEML2EJ9ZO0OE4wxrghKYbMHNUEwxZ23J+lCq2Ce0o1WQSYLI2gTHEE3wQp61udWdoHFxpjrfV6/li6Q22Zi50yeyBf5IM3YBA3sxp8l1A96Mf1CdcIRrAnyZXlmzcuk9xPmhHm6A106q26M/mCCHLoeDBcartRCKfvCBLUVaFWq9mQV9CBl7xsAAP//NXkLXAAAAAZJREFUAwBcw1EpRUIHFAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gengduo_10@2x.png
// module id = 878
// module chunks = 1